import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
    "data-testid": "dashboard-onboarding-incomplete",
    class: "flex flex-col items-center justify-center gap-4 p-8 text-center"
};
const _hoisted_2 = { class: "max-w-md" };
const _hoisted_3 = { class: "text-xl font-semibold text-gray-900 dark:text-gray-100 mb-2" };
const _hoisted_4 = { class: "text-gray-600 dark:text-gray-400 mb-6" };
export default /*@__PURE__*/ _defineComponent({
    __name: 'DashboardOnboardingIncomplete',
    props: {
        title: {},
        message: {},
        actionLabel: {}
    },
    emits: ["action"],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _cache[1] || (_cache[1] = _createElementVNode("svg", {
                    class: "w-16 h-16 text-gray-400 dark:text-gray-500",
                    xmlns: "http://www.w3.org/2000/svg",
                    fill: "none",
                    viewBox: "0 0 24 24",
                    stroke: "currentColor",
                    "aria-hidden": "true"
                }, [
                    _createElementVNode("path", {
                        "stroke-linecap": "round",
                        "stroke-linejoin": "round",
                        "stroke-width": "2",
                        d: "M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                    })
                ], -1 /* CACHED */)),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("h2", _hoisted_3, _toDisplayString(__props.title), 1 /* TEXT */),
                    _createElementVNode("p", _hoisted_4, _toDisplayString(__props.message), 1 /* TEXT */),
                    _createElementVNode("button", {
                        type: "button",
                        class: "inline-flex items-center px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded hover:bg-blue-700 dark:bg-blue-500 dark:hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500 cursor-pointer",
                        onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('action')))
                    }, _toDisplayString(__props.actionLabel), 1 /* TEXT */)
                ])
            ]));
        };
    }
});
